/**
 * @file INCSUBFilterList.js
 * @description A reusable dropdown filter list component for selecting items from a list.
 * The component shows a toggleable dropdown and handles click-outside logic to close it.
 * Useful for filtering data based on a category (like platform, status, type, etc.)
 * 
 * Props:
 * - list: Array of items to show in the dropdown
 * - value: Currently selected item (displayed as default)
 * - func: Callback function triggered on item selection
 * - type: Label type (shown when value is 'All')

 */

import React, { useEffect, useRef, useState } from 'react';
import './styleFilterList.css';

function INCSUBFilterList({ list, value, func, type }) {
    const [isOpenFiletr, setisOpenFilter] = useState(false); // Dropdown open/close state
    const refType = useRef(null); // Ref for the dropdown to detect outside clicks

    /**
     * Closes the dropdown if a click is detected outside the dropdown element.
     */
    const handleClickOutside = (event) => {
        if (refType.current && !refType.current.contains(event.target)) {
            setisOpenFilter(false);
        }
    };

    // Add and clean up the event listener for detecting outside clicks
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className='INCSUBFilterList_filter'>
            {/* Display selected value and toggle dropdown on click */}
            <div
                className='INCSUBFilterList_filter_input'
                onClick={() => setisOpenFilter(!isOpenFiletr)}
            >
                {value}
                <span>
                    {value === 'All' ? `(By ${type})` : null}
                </span>
                {/* Dropdown arrow icon */}
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.3126 5.54697C5.17753 5.68199 4.99437 5.75784 4.8034 5.75784C4.61242 5.75784 4.42926 5.68199 4.2942 5.54697L0.219877 1.47265C0.151088 1.40621 0.0962192 1.32674 0.0584729 1.23887C0.0207266 1.151 0.000858202 1.05649 2.71931e-05 0.96086C-0.000803816 0.865229 0.0174193 0.77039 0.0536329 0.681876C0.0898466 0.593363 0.143326 0.512948 0.21095 0.445324C0.278574 0.3777 0.358988 0.324221 0.447501 0.288008C0.536014 0.251794 0.630854 0.233571 0.726485 0.234402C0.822116 0.235233 0.916624 0.255102 1.00449 0.292848C1.09236 0.330594 1.17184 0.385462 1.23828 0.454251L4.8034 4.01937L8.36852 0.454251C8.50435 0.323056 8.68628 0.250462 8.87512 0.252103C9.06396 0.253744 9.24461 0.329489 9.37814 0.463025C9.51168 0.59656 9.58742 0.777202 9.58907 0.966043C9.59071 1.15488 9.51811 1.33682 9.38692 1.47265L5.3126 5.54697Z"
                        fill="black"
                    />
                </svg>
            </div>

            {/* Dropdown list */}
            {
                isOpenFiletr && (
                    <div ref={refType} className='INCSUBPlatforms_type_filter_list'>
                        <ul>
                            {
                                list && list.length > 0 && list.map((item) => (
                                    <li
                                        key={item.id}
                                        onClick={() => {
                                            func(item);            // Call parent callback with selected item
                                            setisOpenFilter(false); // Close dropdown
                                        }}
                                    >
                                        {item.name}
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                )
            }
        </div>
    );
}

export default INCSUBFilterList;
